// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"563":"8b0c3cdf230e6add","1131":"219a79074e0caf03","4611":"6210bdb9c5f5b61d"}[chunkId] + ".css";
};